
import './App.css';
import React from 'react';
import {Routes, Route, Router} from "react-router-dom"
import Home from './Home';
import MovieBookingPage from './MovieBookingPage';
import Complete from './complete';

const App = () => {
  return (
      <Routes>
        <Route path='/' element={<Home />}/>
        <Route path='/MovieBookingPage' element={<MovieBookingPage />}/>
        <Route path='/complete' element={<Complete />}/>
      </Routes>
  );
}

export default App;
